import { render, staticRenderFns } from "./ObjectTarget.vue?vue&type=template&id=70dce1f3&scoped=true&"
import script from "./ObjectTarget.vue?vue&type=script&lang=js&"
export * from "./ObjectTarget.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTarget.vue?vue&type=style&index=0&id=70dce1f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dce1f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dce1f3')) {
      api.createRecord('70dce1f3', component.options)
    } else {
      api.reload('70dce1f3', component.options)
    }
    module.hot.accept("./ObjectTarget.vue?vue&type=template&id=70dce1f3&scoped=true&", function () {
      api.rerender('70dce1f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/ObjectTarget.vue"
export default component.exports